import type { PricingBannerKey } from '~/modules/pricing/types';

import {
  IPricingBillingBannerKey,
  IPricingCampaignsBannerKey,
  IPricingPageAnalyticBannerKey,
  IPricingTrialBannerKey,
} from '~/modules/pricing/types';

export const STORAGE_DISMISS_KEY = '__gemx_dismissed_';
export const STORAGE_USER_ACTION_KEY = '__gemx_user_action_';

export const DASHBOARD_DISMISS_KEY = {
  GEMX_BETA: 'gemx_beta',
  GET_STARTED: 'get_started',
  RECENT_CAMPAIGNS: 'recent_campaigns',
  WEB_PIXEL: 'web_pixel',
  THEME_APP_EXTENSION: 'theme_app_extension',
  CHANGE_THEME: 'change_theme',
  MAXIMIZE_CAMPAIGN: 'maximize_campaign',
  FAILED_BILLING: 'failed_billing',
  CAP_LIMIT: 'cap_limit',
  SUCCESS_PAYING: 'success_paying',
};

export const PRICING_DISMISS_KEY: Record<PricingBannerKey, string> = {
  ...IPricingTrialBannerKey,
  ...IPricingCampaignsBannerKey,
  ...IPricingPageAnalyticBannerKey,
  ...IPricingBillingBannerKey,
};

export const DASHBOARD_PLAN_KEY = {
  COLLAPSED_PLAN_TRIAL: 'collapsed_plan_trial',
};

export const SHOP_STORAGE_KEY_PREFIX = 'GEMX';

// Source of truth: every shop-scoped action and the value shape it stores.
// - `string[]` — collection (e.g. dismissed entity IDs). Use list helpers.
// - `string`   — single flag. Use getValue/setValue.
export interface ShopStorageSchema {
  DISMISSED_START_CAMPAIGN_SUCCESS_BANNER: string[];
  DISMISSED_EXPERIMENT_TYPE_HELP_BANNER: string;
}

export type ShopStorageAction = keyof ShopStorageSchema;

// Identity map for autocomplete. The mapped type forces it to stay in sync with the schema above.
export const SHOP_STORAGE_ACTION: { [K in ShopStorageAction]: K } = {
  DISMISSED_START_CAMPAIGN_SUCCESS_BANNER: 'DISMISSED_START_CAMPAIGN_SUCCESS_BANNER',
  DISMISSED_EXPERIMENT_TYPE_HELP_BANNER: 'DISMISSED_EXPERIMENT_TYPE_HELP_BANNER',
};
